import { Platform } from 'react-native';
import { datadog } from '@sg/expo-datadog-client';

import { getEnvVars } from '@order/utils';

const environment = getEnvVars();

const TRACING_ORIGINS = [
  'sweetgreen.com',
  'https://order.sweetgreen.com',
  'https://order-development.sweetgreen.com',
  environment.GRAPHQL_ENDPOINT,
];

export const initDatadog = async () => {
  await datadog.init(
    {
      applicationId: environment.DD_RUM_APPLICATION_ID,
      clientToken: environment.DD_RUM_CLIENT_TOKEN,
      env: environment.DD_RUM_ENVIRONMENT,
      serviceName: `order-app-${Platform.OS}`, // RN alias of `service`
      version: environment.APP_VERSION_DATADOG, // this corresponds to APP_BUILD_VERSION which is like 1.2.3-abc654d2; TODO: explore versionSuffix to support EAS Updates
    },
    {
      rumNative: {
        firstPartyHosts: TRACING_ORIGINS,
        sessionSamplingRate: 90,
        resourceTracingSamplingRate: 90,
        telemetrySampleRate: 90,
      },
      rumWeb: {
        allowedTracingOrigins: TRACING_ORIGINS,
        sampleRate: 90,
        premiumSampleRate: 90,
        telemetrySampleRate: 90,
      },
    },
  );
};
